export default __webpack_public_path__ + "static/media/goonj_logo.9b7d0f3d.png";